import { render } from "./MdOverlay.vue?vue&type=template&id=3fa6346e&scoped=true&ts=true"
import script from "./MdOverlay.vue?vue&type=script&lang=ts"
export * from "./MdOverlay.vue?vue&type=script&lang=ts"

import "./MdOverlay.vue?vue&type=style&index=0&id=3fa6346e&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa6346e"]])

export default __exports__